import { useMutation, useQueryClient } from "react-query";
import { INotificationMessageModel } from "../../services/notification-message-service/Models";
import NotificationMessageDataService from "../../services/notification-message-service/NotificationMessageService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { MutationContextType } from "./Common";

import { keys } from "./Keys";



export type UseDeleteNotificationMessageParameters = {
    groupID: number,
} & BaseUseMutationParameters<void, INotificationMessageModel>;

export function useDeleteNotificationMessage({
    groupID,
    onError,
    onSuccess
}: UseDeleteNotificationMessageParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, INotificationMessageModel, MutationContextType>(
        (item) => {
            return NotificationMessageDataService.deleteMessage(
                groupID,
                item.id,
                item.requestID
            );
        },
        {
            onMutate: async (model: INotificationMessageModel) => {

                await queryClient.cancelQueries(keys.all);

                const previousItems = queryClient.getQueryData<INotificationMessageModel[]>(
                    keys.list(
                        groupID
                    )
                );

                queryClient.setQueryData<INotificationMessageModel[]>(
                    keys.list(
                        groupID
                    ),
                    (old?: INotificationMessageModel[]) => {
                        return old?.filter(t => t.id !== model.id) ?? [];
                    }
                );

                return {
                    previousItems
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _runTicket, context) => {

                if (error && context?.previousItems) {
                    queryClient.setQueryData<INotificationMessageModel[]>(
                        keys.list(
                            groupID
                        ),
                        context?.previousItems
                    );
                }

                queryClient.invalidateQueries(keys.lists());
            }
        }
    );
}
